export const formatPostcode = (postcode: string) => {
  postcode = postcode.replace(/\s/g, "").toUpperCase();

  const outwardCode = postcode.substring(0, postcode.length - 3);
  const inwardCode = postcode.substring(postcode.length - 3, postcode.length);

  return `${outwardCode} ${inwardCode}`;
};
